import { render, staticRenderFns } from "./SimpleItemTSCard.vue?vue&type=template&id=29e1187c&"
import script from "./SimpleItemTSCard.vue?vue&type=script&lang=js&"
export * from "./SimpleItemTSCard.vue?vue&type=script&lang=js&"
import style0 from "./SimpleItemTSCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports